// extracted by mini-css-extract-plugin
export var link = "_sd-0";